import React from 'react';
import {CreditCard, Edit} from 'lucide-react';
import {useAuthorization} from '../../../../features/auth/hooks/useAuthorization';
import {PERMISSIONS} from '../../../../constants/permissions';

interface CreditInfoCardHeaderProps {
  onEditClick?: () => void;
}

export const CreditInfoCardHeader: React.FC<CreditInfoCardHeaderProps> = ({onEditClick}) => {
  const {hasPermission} = useAuthorization();
  const canEdit = hasPermission(PERMISSIONS.BILLING_MANAGE);

  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <CreditCard className="h-6 w-6 text-brand-600" />
        <h3 className="text-lg font-semibold text-gray-900">المعلومات الائتمانية</h3>
      </div>
      {canEdit && onEditClick && (
        <button
          onClick={onEditClick}
          className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-brand-600 bg-brand-50 hover:bg-brand-100 rounded-lg transition-colors"
        >
          <Edit className="w-4 h-4" />
          تعديل الحد الائتماني
        </button>
      )}
    </div>
  );
};
